import{jsx as r}from"react/jsx-runtime";import{c as t}from"./createSvgIcon-7d989ad9.js";var a=t(r("path",{d:"M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"}),"NavigateNext");export{a as N};
